import React, { useEffect, useRef, useState } from 'react';
import { X, Plus, Star } from 'lucide-react'; 
import noimage from '../assets/images/no-image.jpeg';
import { apiUrl, assetsUrl } from '../config/Config';
import axios from 'axios';
import { useSelector, useDispatch } from "react-redux";

const safeJsonParse = (value, fallback = []) => {
    if (!value) return fallback;
    if (Array.isArray(value)) return value;
    try {
        return JSON.parse(value) || fallback;
    } catch (error) {
        return fallback;
    }
};

const getProductImage = (product) => {
    const images = safeJsonParse(product?.imagesarr);
    return images[0] ? assetsUrl + "products/" + images[0] : noimage;
};

const RelatedProductCard = ({ product, onOpen, onAdd }) => (
    <div className="product-details-modal-related-card" onClick={() => onOpen(product)}>
        <div className="product-details-modal-related-image-container">
            <img src={getProductImage(product)} alt={product.name} />
        </div>
        <div className="product-details-modal-related-details">
            <p className="product-list-name">{product.name}</p>
            <div className="product-details-modal-related-price-add">
                <span className="product-list-price">₹{product.sellingprice}</span>
                <button
                  className="product-list-add-button"
                  onClick={(event) => {
                    event.stopPropagation();
                    onAdd(product);
                  }}
                >
                  <Plus size={16} />
                </button>
            </div>
        </div>
    </div>
);

const getDiscountPercent = (mrp, sell) => {
    if (!mrp || !sell || mrp <= 0 || sell <= 0) return 0;
  
    const discount = ((mrp - sell) / mrp) * 100;
  
    return Math.round(discount); // or Math.floor / toFixed(2)
};

const ProductDetailsModal = ({ product, onClose }) => {
    const dispatch = useDispatch();
    const modalOverlayRef = useRef(null);
    const modalContentRef = useRef(null);
    const [activeProduct, setActiveProduct] = useState(product);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [quantity, setquantity] = useState(1)
    const cartdata = useSelector((store) => store.userReducer.cartdata);

    console.log('cartdata >>', cartdata);

    useEffect(() => {
      setActiveProduct(product);
    }, [product]);

    const activeProductSlug = activeProduct?.productslug;

    useEffect(() => {
      const fetchProductDetails = async () => {
        if (!activeProductSlug) return;
        try {
          const res = await axios.post(
            apiUrl + "getproductdetails",
            { productid: activeProductSlug },
            { headers: { "Content-Type": "application/json" } }
          );
          if (res.data.status === "success") {
            const nextProduct = res.data.data;
            if (!nextProduct) return;
            setActiveProduct(nextProduct);
            setRelatedProducts(Array.isArray(res.data.relatedproducts) ? res.data.relatedproducts : []);
            setSelectedColor(safeJsonParse(nextProduct.colorsarr)[0] || null);
            setSelectedSize(safeJsonParse(nextProduct.sizearr)[0] || null);
          }
        } catch (error) {
          setRelatedProducts([]);
        }
      };

      fetchProductDetails();
    }, [activeProductSlug]);

    if (!activeProduct) return null;
    
    const handleModalContentClick = (e) => {
        e.stopPropagation();
    };

    const imagesarr = safeJsonParse(activeProduct?.imagesarr);
    const colors = safeJsonParse(activeProduct?.colorsarr);
    const sizes = safeJsonParse(activeProduct?.sizearr);
    var discountpercent = getDiscountPercent(activeProduct?.mrpprice, activeProduct?.sellingprice);
    console.log('discountpercent >>', discountpercent);

    var currentstock = 0;
    if(activeProduct?.stock) {
        currentstock = parseInt(activeProduct?.stock);
    } else {
        currentstock = 0;
    }

    const Handleproductaddtocart = (data) => {
      console.log('data >>', data);
      var prevcartdata = cartdata;
      var newcartdata = [];
      var cartimage = "";
      if(data?.imagesarr) {
        var prevarr = safeJsonParse(data?.imagesarr);
        cartimage = prevarr[0];
      } else {
        cartimage = "";
      }
      const itemDiscountPercent = getDiscountPercent(data?.mrpprice, data?.sellingprice);
      const itemStock = parseInt(data?.stock || 0);
    
      var cartobj = {
        id: data?.id,
        name: data?.name,
        category: data?.category,
        slug: data?.slug,
        subcategory: data?.subcategory,
        cartimage: cartimage,
        price: data?.sellingprice,
        quantity: quantity,
        discountpercent: itemDiscountPercent,
        ogprice: data?.mrpprice,
        stock: itemStock,
      }
      console.log('cartobj >>', cartobj);
      var checkstatus = false;
      for(var i = 0; i < prevcartdata?.length; i++) {
        if(prevcartdata[i].id == data?.id) {
          checkstatus = true;
          var prevobj = prevcartdata[i];
          // prevobj?.quantity =  prevobj?.quantity + 1;
          newcartdata.push(prevobj);
        } else {
          newcartdata.push(prevcartdata[i])
        }
      }
      if(!checkstatus) {
        newcartdata.push(cartobj);
      }
      dispatch({ type: "cartdata", payload: newcartdata });
    }

    const handleOpenRelatedProduct = (relatedProduct) => {
      setActiveProduct(relatedProduct);
      requestAnimationFrame(() => {
        modalContentRef.current?.scrollTo({ top: 0, behavior: "smooth" });
        modalOverlayRef.current?.scrollTo({ top: 0, behavior: "smooth" });
      });
    };
    

    return (
      <div>
        <section>
          <div
            className="product-details-modal-overlay"
            onClick={onClose}
            ref={modalOverlayRef}
          >
            <div
              className="product-details-modal-content"
              onClick={handleModalContentClick}
              ref={modalContentRef}
            >
              <div className="product-details-modal-top-section">
                <div className="product-details-modal-image-section">
                  {imagesarr[0] ? (
                    <img
                      src={assetsUrl + "products/" + imagesarr[0]}
                      alt={activeProduct?.name}
                      className="product-details-modal-main-image"
                    />
                  ) : (
                      <img
                      src={noimage}
                      className="product-details-modal-main-image"
                      alt=""
                    />
                  )}
                </div>

                <div className="product-details-modal-details-section">
                  <div className="product-details-modal-header">
                    <h2 className="product-details-modal-name">
                      {activeProduct.name}
                    </h2>
                    {/* <Heart
                      size={24}
                      className="product-details-modal-wishlist-icon"
                    /> */}
                    {/* <button
                      className="product-details-modal-close-button"
                      onClick={onClose}
                    >
                      <X size={20} className="product-details-modal-wishlist-icon" />
                    </button> */}
                    <button
                      className="product-details-modal-closebtn"
                      onClick={onClose}
                    >
                      <X
                        size={24}
                        className="product-details-modal-wishlist-icon"
                      />
                    </button>
                  </div>

                  <div className="d-flex">
                    <div className="product-details-modal-rating">
                      <Star size={18} fill="#fff" color="#fff" />
                      <span className="product-details-modal-rating-text">
                        {activeProduct?.rating}{" "}
                      </span>
                    </div>
                    <p className="ratingcount">
                      {activeProduct?.rating_count} ratings
                    </p>
                  </div>

                  {activeProduct.descriptiontext && (
                    <div
                      className="product-details-modal-short-description"
                      dangerouslySetInnerHTML={{ __html: activeProduct.descriptiontext }}
                    ></div>
                  )}

                  <div className='d-flex'>
                  {activeProduct?.mrpprice !== activeProduct?.sellingprice && (
                    <span className="product-list-original-price product-modal-mrpprice">
                      {"₹" + activeProduct?.mrpprice}
                    </span>
                  )}
                  <div className="product-details-modal-prices">
                    <span className="product-details-modal-price">
                        ₹{activeProduct.sellingprice}
                    </span>
                  </div>
                  </div>
                  

                  

                  {colors.length > 0 && (
                    <div className="product-details-modal-option-group">
                      <span className="product-details-modal-option-label">
                        Color:
                      </span>
                      <div className="product-details-modal-color-options">
                        {colors.map((color, index) => (
                          <div
                            key={index}
                            className={`product-details-modal-color-swatch ${
                              selectedColor === color
                                ? "product-details-modal-color-swatch-active"
                                : ""
                            }`}
                            style={{ backgroundColor: color }}
                            onClick={() => setSelectedColor(color)}
                          ></div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className="product-details-indo-div-border"></div>

                  {sizes.length > 0 && (
                    <div className="product-details-modal-option-group">
                      <span className="product-details-modal-option-label">
                        Size:
                      </span>
                      <div className="product-details-modal-size-options">
                        {sizes.map((size, index) => (
                          <button
                            key={index}
                            className={`product-details-modal-size-button ${
                              selectedSize === size
                                ? "product-details-modal-size-button-active"
                                : ""
                            }`}
                            onClick={() => setSelectedSize(size)}
                          >
                            {size}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {currentstock > 0 ? 
                  cartdata &&
                  Object.keys(cartdata)?.length > 0 && cartdata?.some((obj) => obj.id === activeProduct?.id) ?
                    <button className="product-details-modal-add-to-cart-button addtocartbtn">
                      Added
                    </button> 
                  :
                    <button className="product-details-modal-add-to-cart-button addtocartbtn" onClick={() => {
                      Handleproductaddtocart(activeProduct);
                    }}>
                      Add To Cart
                    </button>
                   : (
                    <button
                      className="product-details-modal-add-to-cart-button"
                      disabled
                    >
                      Out Of Stock
                    </button>
                  )}

                  <div className="product-details-indo-div-border"></div>

                  <div className="product-details-modal-meta-info">
                    <span className="product-details-modal-meta-label">
                      Tags
                    </span>
                    {activeProduct.tagsarr &&
                      safeJsonParse(activeProduct?.tagsarr).map((cat, index) => (
                        <span
                          key={`cat-${index}`}
                          className="product-details-modal-meta-tag"
                        >
                          {cat}
                        </span>
                      ))}
                  </div>

                  {/* <div className="product-details-modal-meta-info">
                    <span className="product-details-modal-meta-label">
                      Categories
                    </span>
                    {product.categories &&
                      product.categories.map((cat, index) => (
                        <a
                          key={`cat-${index}`}
                          href="#"
                          className="product-details-modal-meta-tag"
                        >
                          {cat}
                        </a>
                      ))}
                  </div> */}

                  {/* <div className="product-details-modal-meta-info">
                    <span className="product-details-modal-meta-label">
                      Sellers
                    </span>
                    <a href="#" className="product-details-modal-meta-value">
                      {product.seller}
                    </a>
                  </div> */}
                </div>
              </div>

              <div className="product-details-modal-bottom-section">
                <div className="product-details-extra-details">
                  {activeProduct.infosectionarr
                    ? safeJsonParse(activeProduct.infosectionarr)?.map((item, index) => {
                        return (
                          <>
                            <h3 className="product-details-extra-details-title">
                              {item?.title}
                            </h3>
                            <div
                              className="product-details-modal-short-description"
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}
                            ></div>
                          </>
                        );
                      })
                    : null}
                </div>

                {relatedProducts.length > 0 && (
                  <div className="product-details-related-products-section">
                    <h3 className="product-details-related-products-title">
                      Related Products
                    </h3>
                    <div className="product-details-related-products-grid">
                      {relatedProducts.map((relProduct) => (
                        <RelatedProductCard
                          key={relProduct.id}
                          product={relProduct}
                          onOpen={handleOpenRelatedProduct}
                          onAdd={Handleproductaddtocart}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
};

export default ProductDetailsModal;
